import { Link } from "react-router-dom";

const LOGO = `${process.env.PUBLIC_URL || ""}/eventimo-logo.png?v=4`;
const LOGO_WHITE = `${process.env.PUBLIC_URL || ""}/eventimo-logo-white.png?v=4`;

export const Logo = ({ light = false }) => (
  <Link to="/" data-testid="logo-link" className="flex items-center gap-2 select-none">
    {light ? (
      <img src={LOGO_WHITE} alt="eventimo.online" className="h-14 sm:h-16 w-auto" />
    ) : (
      <img src={LOGO} alt="eventimo.online" className="h-14 sm:h-16 w-auto" />
    )}
  </Link>
);
